<div class="site-wrapper">
  <aoh-header></aoh-header>
  <main class="site-body" [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </main>
  <aoh-footer></aoh-footer>
</div>
